// reCAPTCHA Configuration
// TODO: Move these to environment variables

// Site key (client-side) - safe to use in frontend
export const RECAPTCHA_SITE_KEY = "6Lek-FwsAAAAAAhMrjtBnIQiayc6uhEADDL61XbQ";

// Note: Secret key (6Lek-FwsAAAAADD6iiFIGhZj-Q8JphNkRMEFj4dR) should ONLY be used on the server-side
// Never expose the secret key in client-side code
